"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _AccountStatsResponse = _interopRequireDefault(require("../model/AccountStatsResponse"));

var _ActionStatsResponse = _interopRequireDefault(require("../model/ActionStatsResponse"));

var _CampaignLinksStatsResponse = _interopRequireDefault(require("../model/CampaignLinksStatsResponse"));

var _CampaignStatsResponse = _interopRequireDefault(require("../model/CampaignStatsResponse"));

var _EmailStatsResponse = _interopRequireDefault(require("../model/EmailStatsResponse"));

var _HTTPBadRequestError = _interopRequireDefault(require("../model/HTTPBadRequestError"));

var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));

var _ListStatsResponse = _interopRequireDefault(require("../model/ListStatsResponse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* Report service.
* @module api/ReportApi
* @version integration550
*/
var ReportApi = /*#__PURE__*/function () {
  /**
  * Constructs a new ReportApi. 
  * @alias module:api/ReportApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ReportApi(apiClient) {
    _classCallCheck(this, ReportApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Callback function to receive the result of the getAccountStats operation.
   * @callback module:api/ReportApi~getAccountStatsCallback
   * @param {String} error Error message, if any.
   * @param {module:model/AccountStatsResponse} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Show account report
   * @param {Number} accountId 
   * @param {Object} opts Optional parameters
   * @param {Number} opts.startTime 
   * @param {Number} opts.endTime 
   * @param {module:api/ReportApi~getAccountStatsCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/AccountStatsResponse}
   */


  _createClass(ReportApi, [{
    key: "getAccountStats",
    value: function getAccountStats(accountId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'accountId' is set

      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getAccountStats");
      }

      var pathParams = {
        'account_id': accountId
      };
      var queryParams = {
        'start_time': opts['startTime'],
        'end_time': opts['endTime']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AccountStatsResponse["default"];
      return this.apiClient.callApi('/reports/accounts/{account_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getActionStats operation.
     * @callback module:api/ReportApi~getActionStatsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ActionStatsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show action report
     * @param {String} workflowId 
     * @param {String} actionId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ReportApi~getActionStatsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ActionStatsResponse}
     */

  }, {
    key: "getActionStats",
    value: function getActionStats(workflowId, actionId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'workflowId' is set

      if (workflowId === undefined || workflowId === null) {
        throw new Error("Missing the required parameter 'workflowId' when calling getActionStats");
      } // verify the required parameter 'actionId' is set


      if (actionId === undefined || actionId === null) {
        throw new Error("Missing the required parameter 'actionId' when calling getActionStats");
      }

      var pathParams = {
        'workflow_id': workflowId,
        'action_id': actionId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ActionStatsResponse["default"];
      return this.apiClient.callApi('/reports/workflows/{workflow_id}/actions/{action_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getCampaignLinksStats operation.
     * @callback module:api/ReportApi~getCampaignLinksStatsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignLinksStatsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show campaign links report
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {Number} opts.startTime 
     * @param {Number} opts.endTime 
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 50)
     * @param {Boolean} opts.withCount  (default to false)
     * @param {String} opts.sort Sort term and direction, using syntax `[-|+]term`.  Valid terms:   - `unique`   - `total`   - `link`
     * @param {module:api/ReportApi~getCampaignLinksStatsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignLinksStatsResponse}
     */

  }, {
    key: "getCampaignLinksStats",
    value: function getCampaignLinksStats(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling getCampaignLinksStats");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'start_time': opts['startTime'],
        'end_time': opts['endTime'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_count': opts['withCount'],
        'sort': opts['sort']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _CampaignLinksStatsResponse["default"];
      return this.apiClient.callApi('/reports/campaigns/{campaign_id}/links', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getCampaignStats operation.
     * @callback module:api/ReportApi~getCampaignStatsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CampaignStatsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show campaign report
     * @param {Number} campaignId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ReportApi~getCampaignStatsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CampaignStatsResponse}
     */

  }, {
    key: "getCampaignStats",
    value: function getCampaignStats(campaignId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'campaignId' is set

      if (campaignId === undefined || campaignId === null) {
        throw new Error("Missing the required parameter 'campaignId' when calling getCampaignStats");
      }

      var pathParams = {
        'campaign_id': campaignId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _CampaignStatsResponse["default"];
      return this.apiClient.callApi('/reports/campaigns/{campaign_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getEmailsStats operation.
     * @callback module:api/ReportApi~getEmailsStatsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EmailStatsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show transactional email report
     * @param {Number} startTime 
     * @param {Number} endTime 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ReportApi~getEmailsStatsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EmailStatsResponse}
     */

  }, {
    key: "getEmailsStats",
    value: function getEmailsStats(startTime, endTime, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'startTime' is set

      if (startTime === undefined || startTime === null) {
        throw new Error("Missing the required parameter 'startTime' when calling getEmailsStats");
      } // verify the required parameter 'endTime' is set


      if (endTime === undefined || endTime === null) {
        throw new Error("Missing the required parameter 'endTime' when calling getEmailsStats");
      }

      var pathParams = {};
      var queryParams = {
        'start_time': startTime,
        'end_time': endTime,
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _EmailStatsResponse["default"];
      return this.apiClient.callApi('/reports/emails', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getListStats operation.
     * @callback module:api/ReportApi~getListStatsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ListStatsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show list report
     * @param {Number} listId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ReportApi~getListStatsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ListStatsResponse}
     */

  }, {
    key: "getListStats",
    value: function getListStats(listId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling getListStats");
      }

      var pathParams = {
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ListStatsResponse["default"];
      return this.apiClient.callApi('/reports/lists/{list_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getSelfAccountStats operation.
     * @callback module:api/ReportApi~getSelfAccountStatsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AccountStatsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show my account report
     * @param {Object} opts Optional parameters
     * @param {Number} opts.startTime 
     * @param {Number} opts.endTime 
     * @param {module:api/ReportApi~getSelfAccountStatsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AccountStatsResponse}
     */

  }, {
    key: "getSelfAccountStats",
    value: function getSelfAccountStats(opts, callback) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'start_time': opts['startTime'],
        'end_time': opts['endTime']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AccountStatsResponse["default"];
      return this.apiClient.callApi('/reports/accounts/self', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return ReportApi;
}();

exports["default"] = ReportApi;